import styled from 'styled-components';

export const CareersStyles = styled.section`
  max-width: 900px;
  width: 100%;
  margin: auto;
  padding: 30px 15px;
  text-align: center;

  .title {
    font-size: 50px;
    line-height: 60px;
    margin: 0;
    font-weight: 600;
    color: #3F5261;
    ${props => props.theme.media.md} {
      line-height: 65.66px;
    }
  }

  .intro-description {
    font-size: 16px;
    line-height: 24px;
    margin: 16px 0 44px 0;
    color: #3F5261;
    ${props => props.theme.media.md} {
      font-size: 18px;
      margin: 8px 0 44px 0;
    }
  }

  .featured-image {
    position: relative;
    max-width: 677px;
    width: 100%;
    margin: auto;
    margin-bottom: 30px;
    display: block;
    ${props => props.theme.media.md} {
      margin: auto;
    }
  }

  .subtitle {
    font-size: 30px;
    line-height: 32px;
    margin: 0;
    color: #3F5261;
    font-weight: 500;
    margin-top: 30px;
    span {
      display: block;
    }
    ${props => props.theme.media.md} {
      margin-top: 0;
      font-size: 30px;
      line-height: 65.66px;
      span {
        display: initial;
      }
    }
  }

  .description2 {
    max-width: 622px;
    width: 100%;
    display: block;
    font-size: 16px;
    line-height: 20px;
    margin: 8px auto 69px auto;
    color: #3F5261;
  }

  .filter-tabs {
    font-size: 16px;
    color: #3F5261;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    margin-left: -10px;
    font-size: 13px;
    ${props => props.theme.media.md} {
      font-size: 16px;
      margin-left: -42px;
      align-items: center;
      justify-content: center;
    }

    span {
      position: relative;
      margin-left: 10px;
      padding-bottom: 0px;
      border-bottom: 4px solid transparent;
      transition: .5s ease all;
      cursor: pointer;
      margin-bottom: 10px;
      ${props => props.theme.media.md} {
        margin-bottom: 0;
        margin-left: 42px;
      }

      &:hover {
        opacity: .8;
        border-bottom: 4px solid #FE6600;
      }

      &.active {
        opacity: 1 !important;
        border-bottom: 4px solid #FE6600;
      }
    }
  }

  .jobs-container {
    margin: auto;
    max-width: 813px;
    width: 100%;
    margin-top: -30px;
    ${props => props.theme.media.md} {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 0;
    }

    .job-post {
      width: 100%;
      max-width: 360px;
      position: relative;
      margin-top: 33px;
      border: 1px solid #3F5261;
      border-radius: 5px;
      padding: 20px;
      padding-bottom: 90px;
      box-shadow: 0 0 15px rgba(0,0,0,0.2);
      margin-left: auto;
      margin-right: auto;
      ${props => props.theme.media.md} {
        width: calc(33% - 20px);
        max-width: 251px;
        margin-left: 0;
        margin-right: 0;
        margin-top: 40px;
      }

      h3 {
        color: #FE6600;
        font-size: 18px;
        line-height: 19px;
        margin-bottom: 7px;
        font-weight: 400;
      }

      .job-location {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 4px;
      }

      .job-type {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 4px;
      }

      .apply-btn {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        color: #fff;
        background: #FE6600;
        width: 125px;
        height: 56px;
        border-radius: 50px;
        font-size: 27px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        ${props => props.theme.media.md} {
          font-size: 14px;
          width: 87px;
          height: 39px;
        }
      }
    }
  }

  

.founded-section {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  margin-bottom: 0;
  text-align: left;
  ${props => props.theme.media.md} {
    margin-bottom: -30px;
  }
  
  .founded-title {
    font-size: 30px;
    color: #3F5261;
    line-height: 42px;
    margin-top: 0;
    margin-bottom: 13px;
    text-align: center;
    font-weight: 500;
    ${props => props.theme.media.md} {
      margin-top: 90px;
      text-align: left;
    }
  }

  .founded-description {
      color: #3F5261;
      font-size: 15px;
      line-height: 28px;
      margin-bottom: 42px;
      ${props => props.theme.media.md} {
        font-size: 16px;
      }
  }

  a.learmore-btn.btn.btn-primary {
      margin-bottom: 59px;
      display: table;
      margin: auto;
      font-weight: 300 !important;
      ${props => props.theme.media.md} {
        margin-left: auto;
        margin-right: 0;
        font-weight: 400 !important;
      }
  }

  img {
      width: 255px;
      display: none;
      ${props => props.theme.media.md} {
        display: block;
      }
  }

  .content {
      width: 100%;
      max-width: 502px;
      ${props => props.theme.media.md} {
        margin-right: 30px;
      }
  }
}

`;
